<template>
    <base-modal
        :ref="modal.key"
        :show="open"
        maxWidth="800"
        :title="modal.title"
        @on-confirm="saveItem"
        @on-cancel="hide()"
        :okText="$t('Save')"
        :closeText="$t('Close')"
        class="link-document-modal"
    >
        <v-form class="my-5">
            <v-text-field
                v-model="description"
                v-bind:label="$t('Description')"
                :error-messages="descriptionErrors"
                @input="$v.description.$touch()"
                @blur="$v.description.$touch()"
            ></v-text-field>
        </v-form>
    </base-modal>
</template>
<script>
import LinkedDocumentService from '@/services/LinkedDocumentService';
import { required, maxLength } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import Utils from '@/ecm/common/Utils';
export default {
    name: 'LinkedDocumentEditModal',
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        descriptionErrors() {
            const errors = [];
            if (!this.$v.description.$dirty) return errors;
            !this.$v.description.required && errors.push(this.$t('RequiredField'));
            !this.$v.description.maxLength &&
                errors.push(
                    this.$t('Site.LinkedDocuments.Messages.InvalidDescription').replace(
                        '{0}',
                        200
                    )
                );
            return errors;
        },
    },
    data() {
        return {
            documentId: null,
            description: '',
            open: false,
            modal: {
                title: this.$t('Site.LinkedDocuments.Titles.EditLinkedDocument'),
                key: 'linkedDocumentEditModal',
            },
        };
    },
    mixins: [validationMixin],
    validations: {
        description: {
            required,
            maxLength: maxLength(200),
        },
    },
    methods: {
        show() {
            this.open = true;
        },
        hide() {
            this.documentId = null;
            this.open = false;
        },
        edit(document) {
            this.show();
            this.documentId = document.id;
            this.description = document.description;
        },
        saveItem() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            const request = {
                description: this.description,
            };
            this.modalInstance.progress(true);
            LinkedDocumentService.edit(this.documentId, request)
                .then(() => {
                    this.hide();
                    this.$emit('on-linked-document-edited');
                    Utils.toast.success(this.$t('DocumentUpdatedSuccessfully'));
                })
                .finally(() => {
                    this.modalInstance.progress(false);
                });
        },
    },
};
</script>